import { DynamicHelperLabelComponent } from './dynamic-helper-label/dynamic-helper-label.component';
import { DynamicSearchErrorComponent } from './dynamic-search-error/dynamic-search-error.component';

export const DYNAMIC_HELPER_COMPONENTS = [
  DynamicHelperLabelComponent,
  DynamicSearchErrorComponent,
];

export * from './dynamic-helper-label/dynamic-helper-label.component';
export * from './dynamic-search-error/dynamic-search-error.component';
